import Vue from 'vue';
import Toasted from 'vue-toasted';
import sanitizeText from './lib/sanitizeText';

Vue.use(Toasted);

const helper = new Vue();

export function errorToast(message, options = {}) {
  const sanitizedMessage = sanitizeText(message);
  helper.$toasted.show(sanitizedMessage, {
    type: 'error',
    theme: 'toasted-primary',
    position: 'top-right',
    duration: 5000,
    iconPack: 'fontawesome',
    icon: 'exclamation-triangle',
    class: 'spireworks_toast success-toast',
    containerClass: 'spireworks_toast_container',
    ...options,
  });
}

export function successToast(message, options = {}) {
  const sanitizedMessage = sanitizeText(message);
  helper.$toasted.show(sanitizedMessage, {
    type: 'info',
    theme: 'toasted-primary',
    position: 'top-right',
    duration: 5000,
    iconPack: 'fontawesome',
    icon: 'info',
    class: 'spireworks_toast error-toast',
    containerClass: 'spireworks_toast_container',
    ...options,
  });
}

// GraphQL mutations return domain errors in the payload's `errors` array even
// when the HTTP request succeeds, so Apollo's `onDone` cannot be used as a
// success signal on its own. This helper surfaces those errors as a toast and
// returns whether the mutation is safe to treat as successful.
export function toastMutationPayload(payload, successMessage) {
  const payloadErrors = payload?.errors ?? [];

  if (payloadErrors.length > 0) {
    errorToast(
      payloadErrors
        .map(e => e.message)
        .filter(Boolean)
        .join('. ')
    );
    return false;
  }

  successToast(successMessage);
  return true;
}
